import { render, staticRenderFns } from "./MicroarrayExperimentDetail.vue?vue&type=template&id=b09485fa&scoped=true"
import script from "./MicroarrayExperimentDetail.vue?vue&type=script&lang=js"
export * from "./MicroarrayExperimentDetail.vue?vue&type=script&lang=js"
import style0 from "./MicroarrayExperimentDetail.vue?vue&type=style&index=0&id=b09485fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b09485fa",
  null
  
)

export default component.exports